import { Typography } from '@/components'
import { Address } from '@/types/address'
import { YearlyCheckInStatus } from '@/types/assessment'
import { FC } from 'react'
import { LocationCard } from './LocationCard'
import {
  DashboardCompanyCard,
  DashboardCompanyCardHeader,
  LocationGrid,
} from './styles'
import { isEmpty } from 'ramda'

interface CompanyDisplayProps {
  companyId?: string
  isHeadquarters?: boolean
  locations: {
    address: Address
    locationId: string
    name: string
    riskScore: number
    essentialCategoryId: string[]
    yearlyCheckInStatus: YearlyCheckInStatus
  }[]
  logoUrl?: string
  name: string
}

export const CompanyDisplay: FC<CompanyDisplayProps> = ({
  name,
  isHeadquarters = true,
  locations,
}: CompanyDisplayProps) => {
  return isEmpty(locations) ? null : (
    <DashboardCompanyCard isHeadquarters={isHeadquarters}>
      <DashboardCompanyCardHeader isHeadquarters={isHeadquarters}>
        <Typography bold variant="h6">
          {name}
        </Typography>
      </DashboardCompanyCardHeader>
      <LocationGrid>
        {locations.map((location) => (
          <LocationCard
            key={location.locationId}
            {...location}
            isHeadquarters={isHeadquarters}
          />
        ))}
      </LocationGrid>
    </DashboardCompanyCard>
  )
}
